import type { NextPage, GetStaticProps, GetStaticPropsContext } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import { COMMON_TRANSLATION_MODULE_NAMES, DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import { DefaultLayout } from '~/shared/layouts'
import { About } from '~/static-pages/About.page'

import Metatags from '~/components/Metadata/Metatags'

import { AppLanguage } from '~/types/locale'

import { usePageTitle } from '~/utils/tags'

const AboutPage: NextPage = () => {
  const { t } = useTranslation('about')

  return (
    <div>
      <Metatags metaDescription={t('metaDescription')} title={usePageTitle(t('title'))} />

      <DefaultLayout zeroPadding>
        <About />
      </DefaultLayout>
    </div>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }: GetStaticPropsContext<{ locale: AppLanguage }>) => {
  return {
    props: {
      ...(await serverSideTranslations(locale as string, [
        ...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES,
        ...COMMON_TRANSLATION_MODULE_NAMES,
        'about',
      ])),
    },
  }
}

export default AboutPage
